import { SimpleToken } from './simple-token';

import { TokenPrice } from './token-price';
import { TokenValue } from './token-value';
import { Type } from 'class-transformer';
import { TransformBigInt } from '../util';

export class Asset {
  @Type(() => SimpleToken)
  public token: SimpleToken;
  @TransformBigInt()
  public balance: bigint;
  @Type(() => TokenPrice)
  public price: TokenPrice;
  @Type(() => TokenValue)
  public value: TokenValue;
  public isTradeable: boolean;
  public isSellable: boolean;

  constructor(
    token: SimpleToken,
    balance: bigint,
    price: TokenPrice,
    value: TokenValue,
    isTradeable: boolean,
    isSellable: boolean,
  ) {
    this.token = token;
    this.balance = balance;
    this.price = price;
    this.value = value;
    this.isTradeable = isTradeable;
    this.isSellable = isSellable;
  }

  public isNative(): boolean {
    return this.token.isNative();
  }
}
